import React, { useCallback } from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import CloneChildren from "@components/children";
import {
  GaragesContainer,
  HeaderSection,
  CountDisplay,
  CountPlus,
  MainHeading,
  SubHeading,
  CardsSection,
  GarageCard,
  GarageName,
  RatingDistance,
  GarageAddress,
  CtaSection,
  CtaText,
  ArrowIconWrapper
} from "./styles";
import ScrewDriverImg from "@public/images/dashcam/ScrewDriver.png";
import CountImage from "@public/images/dashcam/4200.png";
import FullStarIcon from "@public/images/dashcam/full_star.svg";
import ArrowIcon from "@public/images/dashcam/ArrowRight.svg";

export interface IGarage {
  name: string;
  rating: number;
  distance: number;
  address: string;
}

export interface IGarages extends CommonProps {
  garageCount?: string;
  heading?: string;
  subHeading?: string;
  garages?: IGarage[];
  ctaText?: string;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const Garages = ({ children, ...props }: IGarages) => {
  const {
    is_visible,
    garageCount,
    heading,
    subHeading,
    garages,
    ctaText,
    styles,
    actions,
    id
  } = props;
  const { on_click } = actions || {};

  const handleClick = () => {
    if (on_click?.length > 0) {
      on_click?.forEach((eachFunc: any) => {
        typeof eachFunc.funCall === "function" &&
          eachFunc.funCall(eachFunc.args);
      });
    }
  };
  
  const renderCountDisplay = useCallback((count: string) => {
    const plusSign = count.includes('+') ? '+' : '';
    
    return (
      <CountDisplay>
        <img src={CountImage.src} alt="4200+" style={{ width: '118.75px', height: 'auto' }} />
        {plusSign && <CountPlus>{plusSign}</CountPlus>}
      </CountDisplay>
    );
  }, []);

  const renderGarageCards = () => {
    const displayGarages = garages?.slice(0, 4);
    
    return displayGarages?.map((garage, index) => (
      <GarageCard key={index}>
        <GarageName>{garage.name}</GarageName>
        <RatingDistance>
          <FullStarIcon/>
          <span>{garage.rating} rated | {garage.distance} km away</span>
        </RatingDistance>
        <GarageAddress>{garage.address}</GarageAddress>
      </GarageCard>
    ));
  };

  return (id && is_visible) || !id ? (
    <GaragesContainer styles={styles}>
      <HeaderSection>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {renderCountDisplay(garageCount || "")}
          <MainHeading>{heading}</MainHeading>
          <SubHeading>{subHeading}</SubHeading>
        </div>
        <img src={ScrewDriverImg.src} alt="Wrench" />
      </HeaderSection>

      <CardsSection>
        {renderGarageCards()}
      </CardsSection>

      <CtaSection onClick={handleClick}>
        <CtaText> {ctaText}</CtaText>
        <ArrowIconWrapper>
          <ArrowIcon width="24px" height="24px" />
        </ArrowIconWrapper>
      </CtaSection>

      {children && <CloneChildren>{children}</CloneChildren>}
    </GaragesContainer>
  ) : null;
};

export default connect(mapStateToProps)(Garages);